import { V2BsaStrategyTemplateGetPostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import {
  ActionType,
  ActionTypeTime,
  ActionTypeTypeDisplay,
  PVPeriods,
  PeaksAndValleysType,
  PricedisplayType,
  TimeChunk,
} from '../type';
import dayjs from 'dayjs';
import { isNil } from 'lodash-es';

export const isFullDay = (times: ActionTypeTime[], displayType: PricedisplayType) =>
  !getItemTypes(times, displayType).some(t => t === undefined);

export const getItemTypes = (times: ActionTypeTime[], displayType: PricedisplayType) =>
  times.reduce(
    (acc, cur) => {
      acc.splice(
        cur.intervalStart,
        cur.intervalEnd - cur.intervalStart + 1,
        ...new Array(cur.intervalEnd - cur.intervalStart + 1).fill(cur.type)
      );
      return acc;
    },
    [...new Array(displayType === PricedisplayType.HALF ? 48 : 24)]
  );

export const getItemTime = (index: number, displayType: PricedisplayType) => {
  index = displayType === PricedisplayType.HALF ? index : index * 2;
  return zeroPad(Math.floor(index / 2), 2) + ':' + (index % 2 === 0 ? '00' : '30');
};

export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');

export const getPeriodTypes = (times: ActionTypeTime[], displayType: PricedisplayType): ActionTypeTime[] =>
  getItemTypes(times, displayType).reduce((acc, cur, index) => {
    const last = acc[acc.length - 1];
    if (last && last.type === cur) {
      last.intervalEnd = index;
    } else {
      acc.push({
        type: cur,
        intervalStart: index,
        intervalEnd: index,
      });
    }
    return acc;
  }, [] as ActionTypeTime[]);

export const getPeriodTime = (time: ActionTypeTime, displayType: PricedisplayType) =>
  `${ActionTypeTypeDisplay[time.type]}: ${getItemTime(time.intervalStart, displayType)}~${getItemTime(
    time.intervalEnd + 1,
    displayType
  )}`;

export const ChargeList = [PeaksAndValleysType.Flat, PeaksAndValleysType.Valley];
export const DisChargeList = [PeaksAndValleysType.Peak, PeaksAndValleysType.Sharp];

export interface CreatePriceFormProps {
  timePeriodGranularity: PricedisplayType;
  price: ActionTypeTime[];
}

export function getTimeString(record: CreatePriceFormProps) {
  const price = record.price.map(i => {
    const end =
      record.timePeriodGranularity === PricedisplayType.HALF
        ? i.intervalEnd + 1 === 48
          ? 0
          : i.intervalEnd + 1
        : i.intervalEnd + 1 === 24
        ? 0
        : i.intervalEnd + 1;
    const res = {
      type: i.type,
      startTime: getItemTime(i.intervalStart, record.timePeriodGranularity),
      endTime: getItemTime(end, record.timePeriodGranularity),
    };
    return res;
  });
  return price;
}

export function getPriceTimeIndex(record: V2BsaStrategyTemplateGetPostResponse) {
  if (record.additionalFields?.periodTypes === PVPeriods.CustomSettings) {
    const data: ActionTypeTime[] = (record.additionalFields?.chargingAndDischargingPeriodDetail ?? []).map(i => {
      const coefficient = record.additionalFields?.timePeriodGranularity === PricedisplayType.HALF ? 2 : 1;
      const [startHoursStr, startMinuteStr] = (i.startTime as string).split(':');
      const startIndex =
        Number(startHoursStr) * coefficient +
        (record.additionalFields?.timePeriodGranularity === PricedisplayType.HALF
          ? startMinuteStr === '00'
            ? 0
            : 1
          : 0);
      const [endHoursStr, endMinuteStr] = (i.endTime as string).split(':');
      const endIndex =
        Number(endHoursStr) * coefficient +
        (record.additionalFields?.timePeriodGranularity === PricedisplayType.HALF
          ? endMinuteStr === '00'
            ? 0
            : 1
          : 0);
      return {
        type: i.type as ActionType,
        intervalStart: startIndex,
        intervalEnd: endIndex === 0 ? 24 * coefficient - 1 : endIndex - 1,
      };
    });
    return data;
  }
}

export const ChargeListFormat = [
  {
    peakType: PeaksAndValleysType.Flat,
    chargeType: ActionType.Charge,
  },
  {
    peakType: PeaksAndValleysType.Valley,
    chargeType: ActionType.Charge,
  },
  {
    peakType: PeaksAndValleysType.Peak,
    chargeType: ActionType.DisCharge,
  },
  { peakType: PeaksAndValleysType.Sharp, chargeType: ActionType.DisCharge },
];

export function formatEndtime(endTime?: string) {
  let finalEndTime = endTime;
  const formatEndTime = Number(endTime?.split(':')[0]);
  if (formatEndTime === 0) {
    finalEndTime = '24:00';
  }
  return finalEndTime;
}

export function formatSubmitTime(endTime?: string) {
  let finalEndTime = endTime;
  const formatEndTime = Number(endTime?.split(':')[0]);
  if (formatEndTime === 24) {
    finalEndTime = '00:00';
  }
  return finalEndTime;
}

// 验证时间是否满足24小时
export const checekTime24Hour = (timeList: any) => {
  const newList = (timeList ?? [])
    .map((k: any) => {
      if (k.endTime.format('HH:mm') == '00:00') {
        return {
          startTime: k.startTime.valueOf(),
          endTime: k.endTime.add(1, 'days').valueOf(),
        };
      }
      return {
        startTime: k.startTime.valueOf(),
        endTime: k.endTime.valueOf(),
      };
    })
    .sort((a: any, b: any) => a.startTime - b.startTime);

  const seconds = newList.reduce((acc: number, current: TimeChunk) => {
    return acc + current.endTime - current.startTime;
  }, 0);

  const daySeconds = 24 * 60 * 60 * 1000;
  return seconds !== daySeconds;
};

export const disabledTime = (now: any, getFieldValue: any, nowIndex: number, isStart: boolean) => {
  const timeList = getFieldValue('chargingAndDischargingPeriodDetail');

  const nowTime = {
    startTime: timeList[nowIndex]?.startTime?.valueOf(),
    endTime:
      timeList[nowIndex].endTime?.format('HH:mm') === '00:00'
        ? timeList[nowIndex]?.endTime?.add(1, 'days').valueOf()
        : timeList[nowIndex]?.endTime?.valueOf(),
  };

  const deadline = isStart ? nowTime.endTime : nowTime.startTime;

  // step1:把结束时间为00:00加1天,并转化为时间戳
  // step2:对时间戳的开始时间进行排序
  // step3:将时间戳转换为hour和minute
  const newList = timeList
    .filter((m: any, index: number) => index !== nowIndex && m.startTime && m.endTime)
    .map((k: any) => {
      if (k.endTime.format('HH:mm') == '00:00') {
        return {
          startTime: k.startTime.valueOf(),
          endTime: k.endTime.add(1, 'days').valueOf(),
        };
      }
      return {
        startTime: k.startTime.valueOf(),
        endTime: k.endTime.valueOf(),
      };
    })
    .sort((a: TimeChunk, b: TimeChunk) => a.startTime - b.startTime);

  // 针对00:00做特殊判断处理
  const startZeroTime = newList.some((m: TimeChunk) => dayjs(m.startTime).format('HH:mm') === '00:00');
  const endZeroTime = newList.some((m: TimeChunk) => dayjs(m.endTime).format('HH:mm') === '00:00');

  const minutes = new Array(24).fill(0).map((_, hourIndex) => {
    return {
      hour: hourIndex,
      mins: new Array(60).fill(0).map((_, minIndex) => {
        const currentTime = dayjs().hour(hourIndex).minute(minIndex).second(0).millisecond(0).valueOf();

        // const now = dayjs(currentTime).format('HH:mm');

        const nowDisable = isStart ? currentTime > deadline : currentTime < deadline;

        if (hourIndex === 0 && minIndex === 0) {
          return {
            minute: minIndex,
            disabled: isStart ? startZeroTime : endZeroTime,
          };
        }
        return {
          minute: minIndex,
          disabled:
            nowDisable ||
            newList.some((n: any) => {
              if (n.startTime === n.endTime) {
                return currentTime === n.startTime;
              }
              if (isStart && n.startTime === currentTime) {
                return true;
              }
              if (!isStart && n.endTime === currentTime) {
                return true;
              }
              return currentTime > n.startTime && currentTime < n.endTime;
            }),
        };
      }),
    };
  });

  const disabledHours = minutes
    .filter(item => {
      return !item.mins.filter(k => !k.disabled).length;
    })
    .map(m => m.hour);

  return {
    disabledHours: () => {
      return disabledHours;
    },
    disabledMinutes: (selectedHour?: number) => {
      return minutes
        .find(m => m.hour == (selectedHour ?? 0))!
        .mins.filter(k => k.disabled)
        .map(n => n.minute);
    },
  };
};

export const timeValidator = (value: any, getFieldValue: any, index: number) => {
  const timeList = getFieldValue('chargingAndDischargingPeriodDetail');
  const startTime = timeList[index].startTime;
  const endTime = timeList[index].endTime;

  if (isNil(startTime) || isNil(endTime)) {
    return Promise.resolve();
  }

  if (!isNil(startTime) && !isNil(endTime) && endTime.format('HH:mm') != '00:00' && dayjs(startTime).isAfter(endTime)) {
    return Promise.reject(new Error('开始时间需要早于结束时间'));
  }

  const newList = timeList
    .filter((n: any) => !isNil(n.startTime) && !isNil(n.endTime))
    .map((k: any) => {
      if (k.endTime.format('HH:mm') == '00:00') {
        return {
          startTime: k.startTime.valueOf(),
          endTime: k.endTime.add(1, 'days').valueOf(),
        };
      }
      return {
        startTime: k.startTime.valueOf(),
        endTime: k.endTime.valueOf(),
      };
    })
    .sort((a: any, b: any) => a.startTime - b.startTime);

  if (checkTimeOverlap(newList)) {
    return Promise.reject(new Error('与已存在时间段重叠'));
  }

  // if (checekTime24Hour(newList)) {
  //   return Promise.reject(new Error('时间没有满24小时'));
  // }

  return Promise.resolve();
};

// 验证时间是否有重合
export const checkTimeOverlap = (timeList: TimeChunk[]) => {
  if (!timeList.some(k => dayjs(k.startTime).format('HH:mm') === '00:00')) {
    return false;
  }
  if (!timeList.some(k => dayjs(k.endTime).format('HH:mm') === '00:00')) {
    return false;
  }
  for (let i = 0; i < timeList.length - 1; i++) {
    if (timeList[i + 1].startTime < timeList[i].endTime) {
      return true;
    }
  }
  return false;
};
